import { create } from "zustand";

export type NavigationState = {
  profileActiveTab: string;
  settingActiveTab: string;
  dexActiveTab: string;
  // eslint-disable-next-line no-unused-vars
  setProfileActiveTab: (value: string) => void;
  setSettingActiveTab: (value: string) => void;
  setDexActiveTab: (value: string) => void;
  lobbyActiveTab: string;
  setLobbyActiveTab: (value: string) => void;
  activeBonusTab: string;
  setBonusActiveTab: (value: string) => void;
};

const useNavigationStore = create<NavigationState>()((set) => ({
  profileActiveTab: "account",
  setProfileActiveTab: (value) => set({ profileActiveTab: value }),
  dexActiveTab: "trade",
  setDexActiveTab: (value) => set({ dexActiveTab: value }),
  settingActiveTab: "general",
  setSettingActiveTab: (value) => set({ settingActiveTab: value }),
  lobbyActiveTab: "lobby",
  setLobbyActiveTab: (value) => set({ lobbyActiveTab: value }),
  activeBonusTab: "bonus",
  setBonusActiveTab: (value) => set({ activeBonusTab: value })
}));

export default useNavigationStore;
